

























































































import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openList } from '@/main/router/routerPath';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { NdCenik } from '@/modules/sklad/ndCenik';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { editFactory } from '@/main/pages';

import { PAGE_MGR_CLEAR } from '@/main/store/actionTypes';

import { showAlert } from '@/main/utils/notifications';

import { mapActions } from 'vuex';

import { editMutations } from './store/types';
import { NAME, LOCALSTORAGE_STATE_KEY } from './constants';
import { store } from './store/edit';
import { apiProvider as ndSkladApiProvider } from '../../ndSklad/api';

type NdSkladFilter = {
	VyrobekndOzn: string | null;
	NdNr: string | null;
	SkladOzn: number | null;
	NdText: string | null;
	EanCode: string | null;
};

export default editFactory(NAME, store).extend({
	components: {
		SkladMistoSelect: SkladMisto.components.Select,
		NdSkladSelectWithCheck: NdSklad.components.SelectWithCheck,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				sklad: `${this.storeUri}/${editMutations.ND_OBJEDNAVKA_SKLAD_SELECT_MAPPER}`,
				ndSklad: `${this.storeUri}/${editMutations.ND_OBJEDNAVKA_ND_SKLAD_SELECT_MAPPER}`,
			};
		},

		isDisabledKontrolaNd(): boolean {
			return this.isNdNrChosen || this.isNdNrDisabled;
		},
		isMnostviDisabled(): boolean {
			return !!(!this.isCreateMode && this.MnozstviDodano);
		},
		isMioPznDisabled(): boolean {
			return !this.isCreateMode || (this.props.filter ? !!this.props.filter.MioPzn : false);
		},
		isNdNrDisabled(): boolean {
			return !this.isCreateMode || (this.props.filter ? !!this.props.filter.NdNr : false);
		},
		mnozstviZbyva(): number {
			return Math.max(0, this.MnozstviObj! - this.MnozstviDodano!);
		},
		ndskladFilter(): NdSkladFilter {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				SkladOzn: this.SkladOzn,
				NdText: this.Text,
				EanCode: this.EanCode,
			};
		},
	},
	watch: {
		CostPrice(newVal) {
			if (newVal > 0) {
				if (this.dmsSys.EnableGSTPrp) {
					this.edit.TotalCostPrice = newVal * this.edit.MnozstviObj!;
					this.edit.CostPriceWithGST = newVal + (newVal * (this.edit.Gst! / 100));
					this.edit.TotalCostPriceWithGST = this.edit.CostPriceWithGST! * this.edit.MnozstviObj!;
				}
				if (this.dmsSys.EnableVATPrp) {
					this.edit.TotalCostPrice = newVal * this.edit.MnozstviObj!;
					this.edit.CostPriceWithVAT = newVal + (newVal * (this.edit.VAT! / 100));
					this.edit.TotalCostPriceWithVAT = this.edit.CostPriceWithVAT! * this.edit.MnozstviObj!;
				}
			}
		},
		MnozstviObj(newVal) {
			if (newVal > 0) {
				if (this.dmsSys.EnableGSTPrp) {
					this.edit.TotalCostPrice = newVal * this.edit.CostPrice!;
					this.edit.TotalCostPriceWithGST = newVal * this.edit.CostPriceWithGST!;
				}
				if (this.dmsSys.EnableVATPrp) {
					this.edit.TotalCostPrice = newVal * this.edit.CostPrice!;
					this.edit.TotalCostPriceWithVAT = newVal * this.edit.CostPriceWithVAT!;
				}
			}
		},

	},
	methods: {
		...mapActions({
			clearPages: `pageManager/${PAGE_MGR_CLEAR}`,
		}),
		loadedData() {
			if (this.props.filter?.WarehouseId) {
				this.SkladOzn = this.props.filter.WarehouseId;
			}
			if (this.props.filter.Kontrola) {
				this.onKontrolaNdClick();
			}
		},
		onVyrobekNdUpdate() {
			if (this.isNdNrChosen) {
				this.Text = null;
				this.EanCode = null;
				this.NdNr = null;
				this.isNdNrChosen = false;
			}
		},
		async saveClick() {
			if (!this.edit.PrOrdersId!) {
				this.edit.PrOrdersId = this.props.filter.Id;
			}
			if (this.edit.MnozstviObj! <= 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PRAmountValidation'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				});
				return false;
			}
			this.edit.LeftOrderQuantity = this.edit.MnozstviObj;
			this.refreshPreviousPage = true;
			await this.save(true);
			this.openPROrderEdit();
			return true;
		},

		clearSavedState() {
			window.localStorage.removeItem(LOCALSTORAGE_STATE_KEY);
		},
		async openPROrderEdit() {
			this.clearSavedState();
			await this.clearPages();
			openEdit('PROrders', PageMode.EDIT, { id: this.edit.PrOrdersId!, DodavatelId: this.props.filter.DodavatelId });
		},
		async onKontrolaNdClick() {
			if (this.SkladOzn === -1) {
				openList(NdCenik.name, { filter: this.ndskladFilter });
			} else {
				this.startLoading();
				const resp = await ndSkladApiProvider.getPartDetails(this.NdNr!, this.VyrobekndOzn!, this.OrderType!, this.props.filter.DodavatelId!, this.SkladOzn);
				this.endLoading();
				if (!resp.data) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('NDSkladAddManual') });
					return false;
				}
				this.edit.CostPrice = resp.data.LocalRRP;
				this.edit.Ndp = resp.data.Ndp;
				if (this.dmsSys.EnableGSTPrp) {
					this.edit.Gst = resp.data.GSTPercentage;
				}
				if (this.dmsSys.EnableVATPrp) {
					this.edit.VAT = resp.data.VAT;
				}
				const mappedData = {
					value: resp.data.ZaznamId,
					text: resp.data.Text,
					ndnr: resp.data.NdNr,
					cenasdph: resp.data.NcGd,
					vydejmjid: resp.data.VydejMjPoc,
					vyrobekndozn: resp.data.VyrobekndOzn,
				};
				this.$store.commit(this.mutationsMappers.ndSklad, { data: mappedData });
			}
			return true;
		},
		onNdNrInputUpdate(val: string | null) {
			this.NdNr = val;
			if (this.isNdNrChosen) {
				this.Text = null;
				this.EanCode = null;
				this.isNdNrChosen = false;
			}
		},
	},
});
